import axios from "axios";
import {Storage} from "@/Services/Storage";
import Swal from "sweetalert2";
import Vue from "vue";
// import Vue from "vue";
// import {resolve} from "img-vuer/webpack.config";


export default {
    name: 'user',
    state: {
        allUsers: [],
        current_user: null,
        userTypes: ['Super_User', 'Developer', 'Technician', 'Sales'],
        currentSession : undefined,
        attemptedLoginRoute : { name : `SelectRequest` },
        deviceId: null,
    },
    getters: {
        getAllUsers: (state) => state.allUsers,
        getCurrentUser: (state) => state.current_user,
        getSessionID: (state) => state.currentSession,
        getUserTypes: (state) => state.userTypes,
        getDeviceId: (state) => state.deviceId,
    },
    mutations: {
        setDeviceId(state, deviceId) {
            state.deviceId = deviceId;
        },
        setCurrentUser: async (state, data) => {
            state.current_user = data
        },
        clearCurrentUser(state) {
            state.currentUser = null;
        },
        setUsers: async (state, data) => {
            if (data) await Storage.setUsers(data)
            else data = await Storage.getAllUsers();
            state.allUsers = data;
        },
        // setCurrentUser : async (state , payload) => {
        //     if (payload) await Storage.setCurrentUser(payload);
        //     else await Storage.getCurrentUser();
        //     state.currentUser = payload;
        // },
        setSessionID : async (state , payload) => {
            if (payload) await Storage.setSessionID(payload);
            else await Storage.getSessionID();
            state.currentSession = payload;
        },
        setAttemptedRoute: (state, data) => state.attemptedLoginRoute = data,
    },
    actions: {

        getAllUsers: async (context) => {
            return axios.get(ticketApi + `user/getAll`)
                .then(({data}) => {
                    context.commit('setUsers', data)
                    console.log(data)
                });
        },
        validateUser: (context, payload) => {
            return axios.post(ticketApi2 + 'login', payload)
                .then(({data}) => {
                    context.commit('setCurrentUser', data)
                    responses.showSuccess(`Success , Please verify OTP`)
                    return data;
                }).catch(err => errorHandler.tomcatError(err))
        },
        validateUser2: (context, payload) => {
            return axios.post(ticketApi2 + 'verifyOtp', payload)
                .then(async ({data}) => {
                    context.commit('setSessionID', data)
                    responses.showSuccess(`User Log in success`)

                    // Track login
                    const user = await Storage.getCurrentUser();
                    if (user && user.id && window.usageTracker) {
                        window.usageTracker.track('petty-cash', {
                            userId: user.id.toString(),
                            feature: 'auth',
                            action: 'login'
                        });
                    }

                    return user;
                }).catch(err => errorHandler.tomcatError(err))
        },
        getwallets: async (context, queryString) => {
            return axios.get(`${ticketApi2}getRequests?${queryString}`)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err));
        },
        searchUsers: (context, username) => {
            return axios.post(ticketApi + 'user/search', {
                Username : username
            }).then(({data}) => data).catch(err => errorHandler.tomcatError(err))
        },
    }
}
